/*
 * Determines whether the browser is IE using IE only properties
 */
export function isIE(): boolean {
    return !!window.MSInputMethodContext && !!document.DOCUMENT_NODE;
}
